import React, { useState, useEffect } from 'react';

const PrivacyConsent = () => {
  // Start as null so we don't show anything until we check storage
  const [showPopup, setShowPopup] = useState(null); 
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    // 1. Check Local Storage immediately
    const consentGiven = localStorage.getItem('privacyConsent');
    const noShow = localStorage.getItem('privacyNoShow');

    // 2. Logic: Only show if BOTH are missing/null
    if (!consentGiven && !noShow) {
      // Small delay for smooth UX
      setTimeout(() => setShowPopup(true), 500);
    } else {
      // Ensure it stays hidden if they already accepted
      setShowPopup(false);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('privacyConsent', 'true');
    
    // If they checked the box, save that preference too
    if (dontShowAgain) {
      localStorage.setItem('privacyNoShow', 'true');
    }
    
    setShowPopup(false);
  };

  const handleDecline = () => {
    // Even if they decline, if they checked "Don't show again", we respect it
    if (dontShowAgain) {
      localStorage.setItem('privacyNoShow', 'true');
    }
    
    setShowPopup(false);
  };

  // If showPopup is null (checking) or false (hidden), render nothing
  if (showPopup !== true) return null;

  return (
    <div className="privacy-consent-overlay">
      <div className="privacy-consent-box-large">
        <div className="privacy-header">
          <h3><i className="fas fa-shield-alt"></i> Data Privacy & Consent</h3>
          <button className="close-btn" onClick={handleDecline}>&times;</button>
        </div>
        
        <div className="privacy-body">
          <p>
            We value your privacy. We use cookies and similar technologies to enhance your experience, 
            analyze traffic, and for marketing purposes. By clicking <strong>"Accept All"</strong>, 
            you consent to our use of these tools in accordance with our.
            <a href="/privacy-policy" target="_blank" rel="noreferrer"> Privacy Policy</a>
          </p>
          
          <div className="checkbox-wrapper">
            <input 
              type="checkbox" 
              id="dont-show-again" 
              checked={dontShowAgain} 
              onChange={(e) => setDontShowAgain(e.target.checked)} 
            />
            <label htmlFor="dont-show-again">Don't show me this again</label>
          </div>
        </div>

        <div className="privacy-actions-large">
          <button className="btn-decline-large" onClick={handleDecline}>
            Necessary Only
          </button>
          <button className="btn-accept-large" onClick={handleAccept}>
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyConsent;